import { Link } from "react-router";
import logo from "../../assets/images/logo.png";
import styles from "./BrandHeader.module.css";

export const BrandHeader = () => (
  <header className={styles.header}>
    <Link to="/" className={styles.brand}>
      <img src={logo} alt="" className={styles.logo} />
      <span className={styles.name}>
        PQChat <span className={styles.accent}>Rooms</span>
      </span>
    </Link>
  </header>
);
